<div class="load-more-wrapper">
  <div class="load-more-but">
    <button
      id="load-more-button"
      mat-flat-button
      class="mat-primary btn btn-add"
      (click)="loadMore.emit()"
    >
      Load more
    </button>
  </div>
</div>
